import { BaseEntity } from "yt-ng-framework";

export class TipRadneOpremeView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string;
    VelicinaSet: string;
    VelicinaSetID:number=null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.VelicinaSet = input.VelicinaSet;
        this.VelicinaSetID=input.VelicinaSetID;

        return this;
    }

    Serialize(input: TipRadneOpremeView){
        return input;
    }
}